<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-button class="item" icon="icon icon-jiarucopy" @click="on_create()" type="primary" />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{
                    selectedRowKeys: selected_row_keys,
                    onChange: on_selection_change,
                }"
                size="middle"
            >
                <!-- 状态信息 -->
                <template slot="status_render" slot-scope="text">
                    <a-tag color="green" v-if="!text" class="b-tag">正常</a-tag>
                    <a-tag color="red" class="b-tag" v-else>禁用</a-tag>
                </template>

                <template slot="name_render" slot-scope="text, record">
                    <a-tag class="b-tag" :color="record.color">{{ record.name }}</a-tag>
                </template>

                <template slot="front" slot-scope="text">
                    <a-icon type="check" v-if="text" />
                </template>

                <!-- 创建时间 -->
                <template slot="created_render" slot-scope="text">
                    <span v-html="$options.filters['friendly'](moment(text * 1000).format('YYYY-MM-DD HH:mm'))"></span>
                </template>

                <template slot="sort" slot-scope="text, record, index">
                    <div class="sort">
                        <a-button
                            shape="circle"
                            icon="arrow-down"
                            size="small"
                            class="btn"
                            @click="on_sort(record, 'down', index)"
                            v-if="index != data_source.length - 1"
                        />
                        <a-button
                            shape="circle"
                            icon="arrow-up"
                            size="small"
                            class="btn"
                            @click="on_sort(record, 'up', index)"
                            v-if="index != 0"
                        />
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" @click="on_edit(record)" style="margin-right:8px">修改</a-button>

                        <a-button size="small" @click="on_delete(record)" type="danger">删除</a-button>
                    </div>
                </template>
            </a-table>
        </div>

        <modal_create
            :visible="visible_create"
            :mode="create_mode"
            @load="load"
            @close="visible_create = false"
            :record="selected_record"
        />
    </div>
</template>

<script>
    import modal_create from "./modal_create.vue";
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";

    export default {
        mixins: [common_pagination],
        components: {
            modal_create,
        },
        data() {
            return {
                path: "/trademark/tags",
                data_source: [],
                loading: false,
                visible_create: false,
                selected_record: null,
                wd: null,
                create_mode: "create",
                columns: [
                    {
                        dataIndex: "id",
                        title: "ID",
                        width: 60,
                    },
                    {
                        dataIndex: "is_disabled",
                        title: "状态",
                        width: 80,
                        align: "center",
                        scopedSlots: {
                            customRender: "status_render",
                        },
                    },
                    // {
                    //     dataIndex: "is_front",
                    //     width: 80,
                    //     title: "前端展示",
                    //     scopedSlots: {
                    //         customRender: "front",
                    //     },
                    // },
                    {
                        dataIndex: "name",
                        title: "名称",
                        scopedSlots: {
                            customRender: "name_render",
                        },
                    },
                    {
                        dataIndex: "item_count",
                        title: "商标数量",
                        width: 150,
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "created_at",
                        title: "创建时间",
                        width: 150,
                        scopedSlots: {
                            customRender: "created_render",
                        },
                    },
                    {
                        dataIndex: "sort",
                        title: "排序",
                        width: 80,
                        scopedSlots: {
                            customRender: "sort",
                        },
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        align: "center",
                        width: 120,
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        mounted() {
            this.load();
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/trademark/tags?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_create() {
                this.selected_record = {};
                this.create_mode = "create";

                this.visible_create = true;
            },
            on_edit(record) {
                this.selected_record = record;
                this.create_mode = "edit";

                this.visible_create = true;
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: `是否删除【${record.name}】？`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/trademark/tags/" + record.id)
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_sort(item, dir, index) {
                let data_source = JSON.parse(JSON.stringify(this.data_source));
                let new_data_source = [];
                switch (dir) {
                    case "up":
                        data_source[index] = this.data_source[index - 1];
                        data_source[index - 1] = this.data_source[index];
                        break;
                    case "down":
                        data_source[index] = this.data_source[index + 1];
                        data_source[index + 1] = this.data_source[index];
                        break;
                    default:
                        return false;
                }

                this.data_source = data_source;

                this.$http
                    .post("/trademark/tags/sort", {
                        object_id: item.id,
                        dir: dir,
                    })
                    .then((res) => {
                        if (res.success) {
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                            this.load();
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>

<style lang="less" scoped>
    .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
    .banner {
        max-height: 30px;
    }
    .action {
        width: 120px;
    }

    .sort {
        display: flex;
        .btn {
            &:first-child {
                margin-right: 8px;
            }
        }
    }
</style>
